import React from 'react';
import styled from 'styled-components/macro';
import { MomsChange, Money, PriceSum } from '../../../../../containers/commerce';
import { Col, Div } from '../../../../grid';
import { Paragraph, Span } from '../../../../typography';

const PriceStyled = styled(Money)`
  font-size: 24px;
  font-weight: bold;
`;

const PallePriceStyled = styled(PriceSum)`
  font-size: 24px;
  font-weight: bold;
  padding-top: 3px;
  display: inline-block;
`;

const PallePriceStyled2 = styled(PriceSum)`
  font-size: 14px;
  padding-top: 3px;
  display: inline-block;
`;

const RenderLiterStkPris = ({
  price,
  countPrColli,
  isLeje,
}) => {
  return (
    <React.Fragment>
      <Money money={price} multiplier={1 / countPrColli} /> / stk.{isLeje ? ' (Leje)' : ''}<br />
    </React.Fragment>
  );
};

const RenderBottlePrices = ({
  showOnlyPluralPrice,
  price,
  liter,
  countPrColli,
  isLeje,
  productTypePalle,
  varenr,
  productTypeFadoel,
  productTypePack,
  packageNoun,
  priceSuffix,
}) => {
  if (productTypeFadoel || productTypePack) {
    return null;
  }
  if (showOnlyPluralPrice) {
    return (
      <Col xs={12}>
        <Paragraph>
          <PriceStyled money={price} />{priceSuffix && (priceSuffix)} <MomsChange />
          {isLeje ? <React.Fragment><br />(Leje)</React.Fragment> : ''}
        </Paragraph>
      </Col>
    );
  }
  return (
    <Col xs={12}>
      <Paragraph>
        <RenderLiterStkPris price={price} liter={liter} countPrColli={countPrColli} isLeje={isLeje} />
        {!productTypePalle && (
          <React.Fragment>
            <PriceStyled money={price} /> <MomsChange />
          </React.Fragment>
        )}
        {productTypePalle && (
          <React.Fragment>
            <Money money={price} /> / {packageNoun.toLowerCase()}<br />
            <PallePriceStyled itemPrice varenr={varenr} numberOfPaller={0} /> <MomsChange /><br />
            <Div marginTop="10px">
              <PallePriceStyled2 itemPrice moms pant varenr={varenr} numberOfPaller={1} /> <Span inline fontSize="14px">med EUR-palle, pant & moms</Span>
            </Div>
          </React.Fragment>
        )}
      </Paragraph>
    </Col>
  );
};

export default RenderBottlePrices;
